import { BUNDLE } from 'apps/auth/constants/EntryPoint';
import { AUTH_VIEW } from 'apps/auth/constants/ServerConstants';
import DeliveryOptionsPage from 'apps/auth/pages/send/DeliveryOptionsPage';
import GTSendMultiPage from 'apps/auth/pages/send/GTSendMultiPage';
import SendSelectCountryPage from 'apps/auth/pages/send/SendSelectCountryPage';

const authBonus = [
    {
        path: '/auth/profile/bonus/withdraw',
        exact: true,
        component: SendSelectCountryPage,
        view: AUTH_VIEW,
        isAuthZone: true,
        stateOptions: {
            entryPoint: BUNDLE,
            innerPage: true,
            isBonus: true,
        },
    },
    {
        path: '/auth/profile/bonus/withdraw/:countryCodeA2/delivery',
        exact: true,
        component: DeliveryOptionsPage,
        view: AUTH_VIEW,
        isAuthZone: true,
        stateOptions: {
            entryPoint: BUNDLE,
            innerPage: true,
            isGA: false,
            isBonus: true,
        },
    },
    {
        path: '/auth/profile/bonus/withdraw/:countryCodeA2/:currencyIso/:deliveryMethod',
        exact: true,
        component: GTSendMultiPage,
        view: AUTH_VIEW,
        isAuthZone: true,
        stateOptions: {
            entryPoint: BUNDLE,
            innerPage: true,
            isGA: true,
            isBonus: true,
            hideViewRatesFirst: false, // hide temporary
        },
    },
    {
        path: '/auth/profile/bonus/global/withdraw/:deliveryMethod/send',
        exact: true,
        component: GTSendMultiPage,
        view: AUTH_VIEW,
        isAuthZone: true,
        stateOptions: {
            hideViewRatesFirst: true,
            globalFlow: true,
            isBonus: true,
        },
    },
];

export default authBonus;
